import React, { Component } from 'react';
import ItemInnerMainMenu from './ItemInnerMainMenu';
import serverClientUtil from '../../../../utils/serverClientUtil';

class SubcategoriesMultisitesContent extends Component {
  renderCategoryItem = (item, index) => {
    const key = `category-${item.id || index}-${index}`;

    return (
      <ItemInnerMainMenu
        key={key}
        data={item}
      />
    );
  }

  render() {
    const { setAllSubcategoriesMulti, displayList, selectDataLength, selectData } = this.props;
    const limitedDisplayList = Array.isArray(displayList) ? displayList.slice(0, 6) : [];
    const displayShowMoreLink = selectDataLength > 6;

    return (
      <div
        className={`${'dropdownMenuContent'} contentOfSubcategories`}
        onMouseEnter={() => setAllSubcategoriesMulti(true)}
        onMouseLeave={() => setAllSubcategoriesMulti(false)}
      >
        <div className={'containerOfSubcategories'}>
          {limitedDisplayList.map(this.renderCategoryItem)}
        </div>

        {displayShowMoreLink && (
          <div className="showMoreLinkBtn">
            <a
              style={{
                alignItems: 'center',
                padding: '16px 32px',
                color: 'var(--main-color-brand)',
                display: 'flex',
                flexDirection: 'row',
                gap: '4px',
              }}
              href={`${serverClientUtil.getLPURL()}${selectData.url}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              Ver todas las secciones
              <span className="chevron chevronLeft left chevronLeftInnerSubmenuWap" style={{ transform: 'translateY(-4px)' }} />
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default SubcategoriesMultisitesContent;
